// src/components/ui/calendar/week/WeekViewTimeSlot/WeekViewTimeSlotShadcn.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';

const WeekViewTimeSlotShadcn = ({
  date,
  hour,
  dayIndex,
  events = [],
  backgroundEvents = [],
  isClickable = false,
  onClick,
  children,
  // NEW: Availability props
  hasAvailability = false,         // ← ADD THIS
  viewingPartnerAvailability = false, // ← ADD THIS
  className = ''
}) => {
  const handleClick = () => {
    if (isClickable && onClick) {
      onClick(date, hour);
    }
  };

  return (
    <div
      className={cn(
        // Base time slot styling from your current WeekView
        "relative border-r border-slate-600/30 last:border-r-0 h-16 group",
        "transition-colors duration-200",
        isClickable && "cursor-pointer",

        // NEW: Purple availability styling
        hasAvailability && "bg-purple-600/10 border-purple-500/20",
        hasAvailability && "hover:bg-purple-600/20",

        // Original hover (but skip if has availability)
        !hasAvailability && "hover:bg-slate-700/10",

        className
      )}
      onClick={handleClick}
    >
      {/* Partner availability indicator (small dot, non-intrusive) */}
      {hasAvailability && (
        <div className="absolute top-1 right-1 w-1.5 h-1.5 bg-purple-400 rounded-full"></div>
      )}

      {/* Events content */}
      {children}
    </div>
  );
};

export default WeekViewTimeSlotShadcn;